import { Injectable } from '@angular/core';
import { LogService } from './log.service';
import { take, map } from 'rxjs/operators';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalsService } from './globals.service';
import { Database, get, ref, update } from '@angular/fire/database';
import { from } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class IntegrationService {
  thomasAuthorizationURL: string = 'https://identity.thomasinternational.net/connect/token';
  thomasAssessmentOrder: string = 'https://partner.thomasinternational.net/hr/v1/%CLIENTID%/AssessmentOrders/'
  sEndpoint: string = 'https://apis.zenithr.net/api/';//'http://localhost:52619/api/';

  constructor(private db: Database, private logService: LogService, private http: HttpClient, private globals: GlobalsService) {
    this.sEndpoint = this.globals.sEndpoint;
  }

  fetchIntegrations(tenantKey: string) {
    const path = `/Integrations/${tenantKey}`;
    return from(get(ref(this.db, path))).pipe(
      map(snapshot => {
        const data: any[] = [];
        snapshot.forEach(child => {
          data.push({ key: child.key!, ...child.val() });
        });
        return data;
      }),
      take(1)
    );
  }

  createThomasIntegration(tenantKey: string, clientID: string, clientSecret: string) {
    const thomasNode = {
      key: 'THOMAS',
      thomasClientID: clientID,
      thomasClientSecret: clientSecret,
      initialIntegration: true
    };
    const path = `/Integrations/${tenantKey}/${thomasNode.key}`;
    return update(ref(this.db, path), thomasNode);
  }

  authorize(clientID: string, clientSecret: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic ' + btoa(clientID + ':' + clientSecret),
      }),

    };
    let body = new URLSearchParams();
    body.set('grant_type', 'client_credentials');
    //
    return this.http.post<any>(this.thomasAuthorizationURL, body.toString(), httpOptions);

  }

  downloadIntegrationExcelFile(request: any) {
    return this.http.post(this.sEndpoint + 'Integration/DownloadExcelIntgration', request);
  }

  integrate(request: any) {
    return this.http.post(this.sEndpoint + 'Integration/IntegrateExcel', request);
  }



}
